import { ContentManagementService } from '../content-management.service';
import { AppConfigService } from './app-config.service';
import { AuthService } from './auth.service';
import { NotificationService } from './notification.service';

export function appInitializerFactory(
  appConfigService: AppConfigService,
  authService: AuthService,
  notificationService: NotificationService,
  contentManagementService: ContentManagementService
): () => Promise<void> {
  return async (): Promise<void> => {
    try {
      const fullUrl = window.location.href;
      const urlParams = new URLSearchParams(fullUrl.split('?')[1] || '');
      const code = urlParams.get('code');
      const virtualPath = urlParams.get('virtual_path');
      const tpa = urlParams.get('tpa');

      // 1) Load app config and configure OAuth
      await appConfigService.load();

      // ⚠️ Prefer NOT to echo 'code' back via customQueryParams.
      // Let tryLoginCodeFlow() consume it from the current URL.
      authService.setAuthConfig(code, virtualPath, tpa);

      // 2) Run login sequence + other startup work
      await Promise.all([
        authService.runInitialLoginSequence(), // handles code flow if present
        notificationService.setConfig(),
      ]);

      // 3) Now safe to load profile with the freshest AT available
      await authService.loadUserProfile();

    } catch (err) {
      console.error('Error during app initialization:', err);
      throw err;
    }
  };
}
